import React, { useState, useEffect } from "react";
import {
    useNavigate,
  Link,
  useLocation
} from "react-router-dom";
import "../styles/Settings.css";

const API_URL =
  process.env.REACT_APP_API_URL;


/* ─── Icons ─── */
const LayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);
const RepeatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const HelpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

/* ─── Data ─── */
const NAV_ITEMS = [
  { label: "Dashboard", icon: <LayoutIcon />, active: false,path: "/dashboard"  },
  { label: "Conversions", icon: <RepeatIcon />, active: false,path: "/conversions"  },
  { label: "Payments", icon: <CreditCardIcon />, active: false,path: "/payments"  },
  { label: "Settings", icon: <SettingsIcon />, active: true,path: "/settings"  },
  { label: "Help", icon: <HelpIcon />, active: false,path: "/help"  },
];

const NOTIFICATIONS = [
  { id: "email", title: "Email Notifications", desc: "Receive conversion completion alerts via email", default: true },
  { id: "weekly", title: "Weekly Summary", desc: "Receive a weekly digest of your conversion activity", default: true },
];


/* ─── Toggle Switch ─── */
function Toggle({ checked, onChange }) {
  return (
    <button
      className={`st-toggle ${checked ? "st-toggle--on" : ""}`}
      onClick={() => onChange(!checked)}
      role="switch"
      aria-checked={checked}
    >
      <span className="st-toggle-knob" />
    </button>
  );
}

/* ─── Sidebar ─── */
function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentUser = JSON.parse(
      localStorage.getItem("currentUser") || "{}"
    );


    const handleLogout = () => {
              localStorage.removeItem("currentUser");
              localStorage.removeItem("selectedPlan");
              navigate("/");
            };

  return (
    <aside className="st-sidebar">
      <div className="st-sidebar-upper">
        <div className="st-profile">
          <div className="st-avatar">
          {currentUser.full_name
                                            ? currentUser.full_name
                                                .split(" ")
                                                .map((n) => n[0])
                                                .join("")
                                                .substring(0, 2)
                                                .toUpperCase()
                                            : "U"}
                              </div>
          <div className="st-profile-info">
            <span className="st-profile-name">
              {currentUser.full_name || "User"}
            </span>
            <span className="st-profile-role">
              {currentUser.email || ""}
            </span>
          </div>
        </div>
        <nav className="st-nav">
          {NAV_ITEMS.map((item) => (
                                            <Link
                                              key={item.label}
                                              to={item.path}
                                              className={`db-nav-item ${
                                                location.pathname === item.path
                                                  ? "db-nav-item--active"
                                                  : ""
                                              }`}
                                            >
                                              <span className="db-nav-icon">
                                                {item.icon}
                                              </span>
                                              {item.label}
                                            </Link>
                                          ))}
                                      {/* ─── Logout separator + button ─── */}
                                                                              <div className="db-nav-separator" />
                                                                              <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                                                                                <span className="db-nav-icon">
                                                                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                                                    <polyline points="16 17 21 12 16 7" />
                                                                                    <line x1="21" y1="12" x2="9" y2="12" />
                                                                                  </svg>
                                                                                </span>
                                                                                Log Out
                                                                              </button>
        </nav>
      </div>
    </aside>
  );
}

/* ─── Main Content ─── */
function MainContent() {
  const [profile, setProfile] = useState({
    fullName: "",
    email: "",
  });

  const [passwords, setPasswords] = useState({
    current: "",
    newPass: "",
    confirm: "",
  });

    const [sessions, setSessions] = useState([]);

  const [twoFactor, setTwoFactor] = useState(true);

  const currentUser = JSON.parse(
      localStorage.getItem("currentUser") || "{}"
  );
  const userId = currentUser.user_id;

  const [notifications, setNotifications] = useState(
    NOTIFICATIONS.reduce((acc, n) => ({ ...acc, [n.id]: n.default }), {})
  );

    const loadSessions = async () => {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${API_URL}/api/user/sessions/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
        const data = await response.json();
        setSessions(data);
    };

    useEffect(() => {
      loadSessions();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const revokeSession = async (sessionId) => {
      const token = localStorage.getItem("token");

      await fetch(
        `${API_URL}/api/user/sessions/${sessionId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      loadSessions();
    };

    const deleteAccount = async () => {
      const confirmDelete = window.confirm(
        "This action cannot be undone. Delete account?"
      );

      if (!confirmDelete) return;

      try {
        const token = localStorage.getItem("token");

        const response = await fetch(
          `${API_URL}/api/user/account/${userId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Account deletion failed");
        }

        localStorage.clear();
        window.location.href = "/";
      } catch (error) {
        alert(error.message);
      }
    };

    const updateProfile = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await fetch(
          `${API_URL}/api/user/profile/${userId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              full_name: profile.fullName,
              email: profile.email,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to update profile");
        }

        alert("Profile updated successfully");
      } catch (error) {
        alert(error.message);
      }
    };

    const updatePassword = async () => {
      if (passwords.newPass !== passwords.confirm) {
        alert("Passwords do not match");
        return;
      }

      try {
        const token = localStorage.getItem("token");

        const response = await fetch(
          `${API_URL}/api/user/password/${userId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              current_password: passwords.current,
              new_password: passwords.newPass,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Password update failed");
        }

        alert("Password updated successfully");

        setPasswords({
          current: "",
          newPass: "",
          confirm: "",
        });
      } catch (error) {
        alert(error.message);
      }
    };

    const updateTwoFactor = async (enabled) => {
      try {
        const token = localStorage.getItem("token");

        await fetch(`${API_URL}/api/user/2fa`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            enabled,
          }),
        });

        setTwoFactor(enabled);
      } catch (err) {
        console.error(err);
      }
    };

    const loadProfile = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await fetch(
          `${API_URL}/api/user/profile/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();

        setProfile({
          fullName: data.full_name,
          email: data.email,
        });
      } catch (error) {
        console.error(error);
      }
    };
    useEffect(() => {
              loadProfile();
              // eslint-disable-next-line react-hooks/exhaustive-deps
            }, []);

    const loadPreferences = async () => {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${API_URL}/api/user/preferences/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      setNotifications(data);
    };

    useEffect(() => {
          loadPreferences();
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

    const savePreferences = async (updatedPrefs) => {
      const token = localStorage.getItem("token");

      await fetch(
        `${API_URL}/api/user/preferences/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(updatedPrefs),
        }
      );
    };



  return (
    <main className="st-main">
      {/* Page Header */}
      <div className="st-page-header">
        <div>
          <h1 className="st-page-title">Account Settings</h1>
          <p className="st-page-sub">Manage your profile, preferences, and security settings</p>
        </div>
        <button
          className="st-btn-primary"
          onClick={updateProfile}
        >
          Save Changes
        </button>
      </div>

      {/* Two-Column: Profile + Security */}
      <div className="st-two-col">
        {/* Profile Information */}
        <div className="st-card">
          <div className="st-card-header">
            <h4>Profile Information</h4>
            <p>Update your personal information and profile picture</p>
          </div>
          <div className="st-divider" />
          <div className="st-avatar-section">
            <div className="st-avatar-lg">
              {profile.fullName
                ? profile.fullName
                    .split(" ")
                    .map((n) => n[0])
                    .join("")
                    .substring(0, 2)
                    .toUpperCase()
                : "U"}
            </div>
            <button className="st-link-btn">Change Photo</button>
          </div>
          <div className="st-form">
            <div className="st-field">
              <label className="st-label">Full Name</label>
              <input className="st-input" value={profile.fullName}
                onChange={(e) => setProfile({ ...profile, fullName: e.target.value })} />
            </div>
            <div className="st-field">
              <label className="st-label">Email Address</label>
              <input className="st-input" type="email" value={profile.email}
                onChange={(e) => setProfile({ ...profile, email: e.target.value })} />
            </div>
          </div>
          <button
            className="st-btn-primary st-btn-full"
            onClick={updateProfile}
          >
            Update Profile
          </button>
        </div>

        {/* Security Settings */}
        <div className="st-card">
          <div className="st-card-header">
            <h4>Security Settings</h4>
            <p>Manage your credentials, dual authentication, and active sessions</p>
          </div>
          <div className="st-divider" />
          <h5 className="st-section-title">Change Password</h5>
          <div className="st-form">
            <div className="st-field">
              <label className="st-label">Current Password</label>
              <input className="st-input" type="password" placeholder="••••••••••••"
                value={passwords.current}
                onChange={(e) => setPasswords({ ...passwords, current: e.target.value })} />
            </div>
            <div className="st-field">
              <label className="st-label">New Password</label>
              <input className="st-input" type="password" placeholder="••••••••••••"
                value={passwords.newPass}
                onChange={(e) => setPasswords({ ...passwords, newPass: e.target.value })} />
            </div>
            <div className="st-field">
              <label className="st-label">Confirm Password</label>
              <input className="st-input" type="password" placeholder="••••••••••••"
                value={passwords.confirm}
                onChange={(e) => setPasswords({ ...passwords, confirm: e.target.value })} />
            </div>
          </div>
          <div className="st-field-action">
            <button
              className="st-link-btn st-link-blue"
              onClick={updatePassword}
            >
              Update Password
            </button>
          </div>

          <div className="st-divider" />

          <div className="st-toggle-row">
            <div>
              <strong>Two-Factor Authentication</strong>
              <p className="st-toggle-desc">Add an extra layer of security to your account.</p>
            </div>
            <Toggle
              checked={twoFactor}
              onChange={updateTwoFactor}
            />
          </div>

          <div className="st-divider" />

          <h5 className="st-section-title">Active Sessions</h5>

          {Array.isArray(sessions) &&
            sessions.map((session) => (
            <div key={session.id} className="st-session">
              <div>
                <span className="st-session-device">
                  {session.device}
                </span>

                {session.current ? (
                  <div className="st-session-meta">
                    <span className="st-session-current">
                      Current Session
                    </span>
                    <span className="st-session-badge">
                      This Device
                    </span>
                  </div>
                ) : (
                  <span className="st-session-time">
                    {session.last_active}
                  </span>
                )}
              </div>

              {!session.current && (
                <button
                  className="st-revoke-btn"
                  onClick={() => revokeSession(session.id)}
                >
                  Revoke
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Notification Preferences */}
      <div className="st-card">
        <div className="st-card-header">
          <h4>Notification Preferences</h4>
          <p>Stay up-to-date with your conversion pipeline actions</p>
        </div>
        <div className="st-divider" />
        {NOTIFICATIONS.map((n, i) => (
          <React.Fragment key={n.id}>
            <div className="st-toggle-row">
              <div>
                <strong>{n.title}</strong>
                <p className="st-toggle-desc">{n.desc}</p>
              </div>
              <Toggle
                checked={notifications[n.id]}
                onChange={(val) => {
                  const updated = {
                    ...notifications,
                    [n.id]: val,
                  };

                  setNotifications(updated);
                  savePreferences(updated);
                }}
              />
            </div>
            {i < NOTIFICATIONS.length - 1 && <div className="st-divider" />}
          </React.Fragment>
        ))}
      </div>

      {/* Danger Zone */}
      <div className="st-card st-danger-card">
        <div className="st-card-header">
          <h4 className="st-danger-title">Danger Zone</h4>
          <p className="st-danger-sub">Irreversible destructive settings regarding your ConvertPro account and history</p>
        </div>
        <div className="st-divider st-divider-danger" />
        <div className="st-danger-row">
          <div>
            <strong>Delete Account</strong>
            <p className="st-toggle-desc">Permanently delete your account, pipelines, payment methods, and all historical data</p>
          </div>
          <button
            className="st-btn-danger"
            onClick={deleteAccount}
          >
            Delete Account
          </button>
        </div>
      </div>
    </main>
  );
}

/* ─── Settings Page ─── */
export default function ConvertProSettings() {
  return (
    <div className="st-layout">
      <Sidebar />
      <MainContent />
    </div>
  );
}
